// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b9d00710","372":"98749092","421":"06d71af8","485":"387ae207","507":"99ee408b","566":"a1447386","747":"7885ca9f"}[chunkId] + ".js";
};